import { Popover, Select } from "antd";
import { InfoCircleOutlined } from '@ant-design/icons'
import { getPopupContainer } from "../../../../../helpers/popUp";

export default function CustomSelect({
  options = [],
  value,
  onChange = () => { },
  label = '',
  placeholder,
  tooltip,
  disabled,
}) {
  return (
    <div className="row-item flex-c">
      <div className="flex mb-2">
        <label className="label">{label}</label>
        {!!tooltip ? typeof tooltip === 'object' ? (
          <div className="ml-1">
            <Popover rootClassName="header-tooltip" content={tooltip.content} title={tooltip.title}>
              <InfoCircleOutlined className="tooltip-icon" />
            </Popover>
          </div>
        ) : (
          <div className="ml-1">
            <Popover content={tooltip}>
              <InfoCircleOutlined className="tooltip-icon" />
            </Popover>
          </div>
        ) : null}
      </div>
      <Select
        value={value}
        disabled={disabled}
        onChange={onChange}
        {...getPopupContainer()}
        placeholder={placeholder || label}
        allowClear
      >
        {options.map((opt, i) => (
          <Select.Option
            key={`options-${opt.value}-${i}`}
            value={opt.value}
            disabled={opt.disabled}
          >
            {opt.label}
          </Select.Option>
        ))}
      </Select>
    </div>
  )
}
